import tw from 'twin.macro';

// for the search component.
export const SearchWrap = tw.div`flex mt-8 pb-4 lg:ml-20`;

export const SearchImage = tw.img`lg:w-80 lg:h-64 2xl:w-96 2xl:h-72 
 md:w-60 md:h-50 lg:-mr-32 w-40 h-28 object-contain mt-10`;

export const SearchTextWrap = tw.div`flex flex-col ml-6 lg:ml-16`;

export const H4 = tw.h4`lg:text-3xl text-xl 2xl:text-4xl font-medium`;

export const H2 = tw.h2`lg:text-5xl text-3xl 2xl:text-6xl
 my-2 lg:my-4 lg:tracking-wider tracking-widest font-medium text-adminsecondary`;

export const SearchInput = tw.input`border md:-ml-0 -ml-32
 mb-8 mt-20 lg:mt-14 lg:mt-10 rounded py-3 pl-2 md:pl-4 bg-gray-200 outline-none
 border-gray-200 font-normal text-gray-800 `;

export const SearchButton = tw.button`px-2 md:-ml-0
 font-semibold w-full -ml-14 lg:w-1/4 mb-6 mt-4 lg:my-2
 py-3 md:mx-0 rounded-lg bg-cto text-white text-lg lg:text-2xl text-center!`;

export const Notice = tw.p`md:text-center md:-ml-0 -ml-32
 md:mt-14 mt-16 mb-3 lg:mb-0 font-thin text-lg md:w-11/12`;

export const NoticeIcon = tw.i`text-cto`;

// for the no time table component.
export const NotimetableWrap = tw.div`text-center mx-auto mt-6 pb-6`;

export const Oops = tw(H2)`text-red-600!`;

export const H5 = tw(H4)`my-4`;

export const NodataSVG = tw.img`object-contain -mt-1 w-80 mx-auto h-80`;
